<p class="section-header">
  <ng-content></ng-content>
</p>
